import React from "react";
import "./DataProcessAnimation.css";

/**
 * Renderiza o componente DataProcessAnimation.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.className - Classe CSS adicional aplicada ao elemento raiz.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const DataProcessAnimation = ({ className = "" }) => {
  return (
    <div className={`data-process-animation ${className}`}>
      {/* Partículas de dados em movimento */}
      <div className="data-particle"></div>
      <div className="data-particle"></div>
      <div className="data-particle"></div>
      <div className="data-particle"></div>
      <div className="data-particle"></div>

      {/* Linha de conexão */}
      <div className="connection-line"></div>

      {/* Ícone de dados (entrada) */}
      <div className="icon-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="data-icon"
          width="21"
          height="21"
          viewBox="0 0 768 768"
        >
          <path d="M677.376 169.632l-264-130.752c-18.496-9.152-40.288-9.152-58.72 0l-264.032 130.752c-22.432 11.040-36.608 33.728-36.608 58.656v311.136c-0.16 24.928 13.888 47.744 36.256 58.912l264.032 130.816c18.624 9.184 40.512 9.184 59.072 0l264-130.816c22.464-11.008 36.608-33.696 36.608-58.464v-311.584c0-24.928-14.144-47.616-36.608-58.656zM374.176 78.304c3.040-1.504 6.432-2.304 9.824-2.304 3.424 0 6.816 0.8 9.888 2.304l245.632 121.696-255.52 126.592-255.488-126.624 245.664-121.664zM109.792 558.88c-7.296-3.616-11.872-11.008-11.776-19.168v-305.728l264 130.784v319.040l-252.224-124.928zM658.016 558.784l-252.032 124.864v-318.88l263.968-130.784v305.856c0.032 8.064-4.544 15.36-11.936 18.944z" />
        </svg>
      </div>

      {/* Ícone do servidor (processamento) */}
      <div className="icon-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="server-icon"
          width="24"
          height="24"
          viewBox="0 0 768 768"
        >
          <path d="M185.984 230.016c-11.424 0-22.88-4.832-31.232-12.8-7.936-8.512-12.736-19.968-12.736-31.456 0-11.552 4.832-23.040 12.768-31.456 16.704-16.384 46.176-16.384 62.464 0 7.936 8.448 12.768 19.904 12.768 31.456 0 11.488-4.832 22.976-12.768 31.424-8.384 7.968-19.808 12.832-31.264 12.832zM736 32v176c0 72.768-59.232 132-132 132h-572v-176c0-72.768 59.232-132 132.032-132h571.968zM692 76h-527.968c-48.576 0-88.032 39.488-88.032 88v132h528c48.544 0 88-39.488 88-88v-132zM217.248 613.184c7.936-8.48 12.768-19.936 12.768-31.424 0-11.552-4.832-23.040-12.768-31.456-16.288-16.384-45.76-16.384-62.464 0-7.936 8.448-12.768 19.904-12.768 31.456 0 11.488 4.832 22.976 12.768 31.424 8.352 7.968 19.808 12.8 31.232 12.8s22.848-4.832 31.232-12.8zM736 428v176c0 72.768-59.232 132-132 132h-572v-176c0-72.768 59.232-132 132.032-132h571.968zM692 472h-527.968c-48.576 0-88.032 39.488-88.032 88v132h528c48.544 0 88-39.488 88-88v-132z" />
        </svg>
      </div>

      {/* Ícone de relatório (saída) */}
      <div className="icon-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="report-icon"
          width="21"
          height="21"
          viewBox="0 0 768 768"
        >
          <path d="M647.936 208l-176-176h-307.936c-24.32 0-44 19.744-44 44v616c0 24.256 19.68 44 44 44h440c24.32 0 44-19.744 44-44v-484h-0.064zM472 94.368l113.728 113.632h-113.728v-113.632zM604 692h-440v-616h264v132c0 24.256 19.68 44 44 44h132v440z" />
          <path d="M384.224 268.352v189.024l-157.888-103.552c-19.552 29.76-31.136 65.28-31.136 103.552 0 104.384 84.64 189.024 189.024 189.024s189.024-84.64 189.024-189.024-84.64-189.024-189.024-189.024z" />
          <path d="M352.512 240c-53.984 0-101.376 27.808-128.96 69.824l128.96 84.576v-154.4z" />
        </svg>
      </div>
    </div>
  );
};

export default DataProcessAnimation;
